import { render } from "./past.vue?vue&type=template&id=06669486&scoped=true"
import script from "./past.vue?vue&type=script&lang=js"
export * from "./past.vue?vue&type=script&lang=js"

import "./past.vue?vue&type=style&index=0&id=06669486&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06669486"]])

export default __exports__